// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import { registerDirectUploadFieldController } from "@swiftvee/bootstrap-concerns"

import ConfirmationController from "./confirmation_controller.js"
import ConfirmationsContentController from "./confirmations/content_controller.js"
import CopyToClipboardController from "./copy_to_clipboard_controller.js"
import DisplayController from "./display_controller.js"
import DynamicFormFieldsController from "./dynamic_form_fields_controller.js"
import FormAutoSubmitController from "./form_auto_submit_controller.js"
import InitialReactNativeTokenUpsertController from "./initial_react_native_token_upsert_controller.js"
import QuoteFormController from "./quote_form_controller.js"
import RequestNotificationPermissionModalController from "./request_notification_permission_modal_controller.js"
import RoleSelectorController from "./role_selector_controller.js"
import SaveButtonToggleController from "./save_button_toggle_controller.js"
import SearchController from "./search_controller.js"
import SelectAllController from "./select_all_controller.js"
import ShowHideController from "./show_hide_controller.js"
import TooltipController from "./tooltip_controller.js"
import TurnstileController from "./turnstile_controller.js"

registerDirectUploadFieldController(application)

application.register("confirmation", ConfirmationController)
application.register("confirmations--content", ConfirmationsContentController)
application.register("copy-to-clipboard", CopyToClipboardController)
application.register("display", DisplayController)
application.register("dynamic-form-fields", DynamicFormFieldsController)
application.register("form-auto-submit", FormAutoSubmitController)
application.register("initial-react-native-token-upsert", InitialReactNativeTokenUpsertController)
application.register("quote-form", QuoteFormController)
application.register("role-selector", RoleSelectorController)
application.register("request-notification-permission-modal", RequestNotificationPermissionModalController)
application.register("save-button-toggle", SaveButtonToggleController)
application.register("search", SearchController)
application.register("select-all", SelectAllController)
application.register("show-hide", ShowHideController)
application.register("tooltip", TooltipController)
application.register("turnstile", TurnstileController)
